import type { VaultConfirmDialogConfig, VaultReasonConfirmDialogConfig } from '@nebula-shared/ui';

export type RetentionPolicyConfirmAction = 'activate' | 'deactivate' | 'delete';
export type RetentionDocumentConfirmAction = 'suspend' | 'resume';

export function retentionPolicyConfirmConfig(
  action: RetentionPolicyConfirmAction,
  name: string,
): VaultConfirmDialogConfig {
  if (action === 'activate') {
    return {
      title: 'Activar política',
      message: `¿Activar «${name}»? Volverá a aplicarse según su configuración.`,
      confirmLabel: 'Activar',
      variant: 'warning',
    };
  }
  if (action === 'deactivate') {
    return {
      title: 'Desactivar política',
      message: `¿Desactivar «${name}»? Dejará de aplicarse hasta que se reactive.`,
      confirmLabel: 'Desactivar',
      variant: 'warning',
    };
  }
  return {
    title: 'Eliminar política',
    message: `¿Eliminar «${name}»? Esta acción no se puede deshacer. Si tiene retenciones activas, el servidor rechazará la operación.`,
    confirmLabel: 'Eliminar',
    variant: 'error',
  };
}

export function retentionDocumentConfirmConfig(
  action: RetentionDocumentConfirmAction,
): VaultConfirmDialogConfig | VaultReasonConfirmDialogConfig {
  if (action === 'resume') {
    return {
      title: 'Confirmar reanudación',
      message: 'Esta acción reactivará el calendario del documento.',
      confirmLabel: 'Reanudar',
      variant: 'warning',
    };
  }
  return {
    title: 'Confirmar suspensión',
    message: 'La suspensión detiene temporalmente el vencimiento de la retención.',
    confirmLabel: 'Suspender',
    variant: 'warning',
    reasonLabel: 'Motivo de suspensión',
    reasonPlaceholder: 'Describe por qué se suspende',
    requireReason: false,
  };
}
